export const COOKIE_NAME = 'searchFullCPG';
